import React from "react";
import Spinner, { SPINNER_CSS } from "./AppSpinner.mjs";

// The document, auth check and lazy route fallback share one first frame.
// Keep this independent of fonts, theme context and downloaded stylesheets.
export default function AppBootScreen() {
  return React.createElement("div", {
    "data-app-boot": "",
    role: "status",
    "aria-label": "Loading",
    style: {
      minHeight: "100vh", display: "grid", placeItems: "center",
      background: "#0a0f1a",
    },
  }, React.createElement("style", null, SPINNER_CSS), React.createElement(Spinner));
}
